/**
 * Created by Alex Xia on 12/17/2018.
 * Description:
 * Add contact header component
 *
 * ------ maintenance history ------
 * Modified by Bowen Li on 2019/7/8: clear the tooltip on ipad
 * Modified by Abner Sui on 2019/11/06: Delete useless code
 */

import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { EntityDetailConfig } from './entity-detail.config';
import { EntityDialogOpenOptions, EntityDialogType } from '../entity-dialog/entity-dialog.model';
import { EntityDialogService } from '../entity-dialog/entity-dialog.service';
import { ScreenHelperService } from '../../services/screen-helper.service';
import { SystemUser } from '../../tamalelibs/models/user.model';
import { StoreQuerierService } from '../../services/store-querier.service';
import { Router } from '@angular/router';
import { ScreenActionTypes } from '../../redux/actions/screen.actions';
import { EntityType } from '../../tamalelibs/models/entity-type.model';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DeviceDetectorService } from 'ngx-device-detector';
import { businessConstants } from '../../constants/business.constants';

@Component({
    selector: 'entity-header',
    templateUrl: './entity-header.component.html',
    styleUrls: ['./entity-header.component.scss']
})
export class EntityHeaderComponent implements OnInit {
    @Input() config: EntityDetailConfig;
    @Input() eventKey?: string;
    @Input() eventValue?: string;
    @ViewChild(TooltipDirective, { static: false })
    public toolTipDir: TooltipDirective;

    isPPCUser = false;
    canEdit = true;
    isIPAD = false;

    private _currentUser: SystemUser;

    constructor(
        private _deviceService: DeviceDetectorService,
        private _store: Store<string>,
        private _screenHelperService: ScreenHelperService,
        private _entityDialogService: EntityDialogService,
        private _storeQuerier: StoreQuerierService,
        private _router: Router
    ) {
        this.isIPAD = this._deviceService.isMobile() || this._deviceService.isTablet();
    }

    ngOnInit() {
        this._currentUser = this._storeQuerier.getCurrentUser();
        // PPC user can save
        if (this._currentUser) {
            this.isPPCUser = this._currentUser.credential.publishPubConfiguration;
        }

        if (this.config && this.config.entity) {
            this._refresh();
        }
    }

    diableLink(event: Event) {
        event.preventDefault();
    }

    getDisplayName(): string {
        let displayName = '';
        if (this.config && this.config.entity) {
            displayName = this.config.entity.name === this.config.entity.shortName ? this.config.entity.name
                : (this.config.entity.shortName + ' (' + this.config.entity.name + ')');
        }
        return displayName;
    }

    goToEntityDetail() {
        const currentPageInfo: any = {
            name: '',
            type: 'EntityDetial'
        };
        this._store.dispatch({
            type: ScreenActionTypes.SET_VALUE,
            payload: currentPageInfo
        });
        this._router.navigate(['entity', this.config.entity.id]);
        if (this.isIPAD) {
            this.toolTipDir.showOn = 'none';
        }
        this._screenHelperService.open$.next(businessConstants.entityScreen.closeEntityScreen);
    }

    onSaveClick() {
        this._saveTabsOnEntityScreen();
    }

    public editEntity() {
        const _entityDialogOpenOptions = new EntityDialogOpenOptions();
        _entityDialogOpenOptions.openType = EntityDialogType.EditEntity;
        _entityDialogOpenOptions.entityId = this.config.entity.id;
        _entityDialogOpenOptions.eventKey = this.eventKey;
        _entityDialogOpenOptions.eventValue = this.eventValue;
        this._entityDialogService.dialogOpen$.next(_entityDialogOpenOptions);

        if (this.isIPAD) {
            this.toolTipDir.showOn = 'none';
        }
    }

    private _saveTabsOnEntityScreen() {
        this._screenHelperService.saveScreen$.next();
    }

    private _refresh() {
        // if entity is team, need manageTeam credential
        if (this.config.entity.type && this.config.entity.type.id === EntityType.TEAM.id) {
            this.canEdit = this._currentUser.credential.manageTeam;
        } else {
            this.canEdit = true;
        }
    }
}


